export default ({ router }) => router
